import { ActionTree, ActionContext } from 'vuex';
import { State } from '@/stores/environment/state';
import { EnvironmentApi } from '@/api/environment-api';

const api = new EnvironmentApi();

export class Actions implements ActionTree<State, any> {
    [key: string]: ((injectee: ActionContext<State, any>, payload: any) => any);

    public fetchAsync = async (context: ActionContext<State, any>) => {
        const result = await api.fetchAsync();
        context.commit('setEnvironment', result.environment);
        context.commit('setVersion', result.version);
    }
}
